import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import numeral from 'numeral';
// import { SanitizeHtml } from '@bd/bdcore-utilities';
import RawPlatMap from '@bd/bdui-platmap';

const PlatMap = withData(
  {
    community: true,
    lots: true,
    homes: true,
  },
  {
    community: true,
  },
)(RawPlatMap);

const styles = css`
  padding: 40px 0;
  @media(min-width: 992px) {
    padding: 70px 0;
  }

  h3, h4 {
    text-align: center;
  }

  .SitePlanModal_platMap .leaflet-container {
    height: 600px;
  }

  .SmothLink_wrapper {
    padding: 20px 0;
    @media(min-width: 768px) {
      padding: 50px 0;
    }
  }

  .leaflet-popup-content-wrapper {
    border-radius: 0;
    .HomePopup_wrapper {
      display: flex;
      a {
        display: flex;
        flex-direction: column;
        color: #242424;
        .HomePopup_title {
          color: #00446a;
          text-align: left;
          font-weight: 700;
          font-size: 19px;
          letter-spacing: 0;
          margin: 0;
        }
        .HomePopup_address {
          font-size: 13px;
          letter-spacing: 0;
          text-transform: uppercase;
        }
        .HomePopup_status {
          text-transform: uppercase;
          font-size: 12;
          font-weight: 800;
          color: #00446a;
        }
        .Btn_learnMore {
          background-color: #00446a;
          height: 30px;
          margin-top: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          text-transform: uppercase;
          font-weight: 800;
          font-size: 11px;
        }
        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
  .leaflet-container {
    height: 100%;
  }
  .PopUpCard_wrapper {
    display: flex;
    flex-direction: column;
    .PopUpCard_title {
      font-size: 15px;
      color: #003451;
      margin-bottom: 5px;
      font-weight: 800;
      text-align: left;
    }
    .PopUpCard_item {
      font-size: 12px;
    }
    .PopUpCard_link {
      position: relative;
      background-image: url('/images/icon-circle-arrow-blue.svg');
      background-position: 75px center;
      background-repeat: no-repeat;
      background-size: 29px 29px;
      height: 40px;
      display: flex;
      align-items: center;
    }
  }
  .leaflet-popup-content {
    width: 145px !important;
  }
`;

function CommunitySitePlan({ community }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="SitePlanModal_body">
          <div className="container">
            <div className="row">
              <div className="col-12 SitePlanModal_platMap">
                <PlatMap
                  shapeStatusStyles={{
                    home: {
                      active: {
                        color: 'rgb(255,193,7)',
                      },
                      'under-construction': {
                        color: 'rgb(255,193,7)',
                      },
                    },
                  }}
                  shapes
                  boundarySize={1}
                  community={community}
                  popup={({ marker }) => (
                    <div className="home-popup HomeCardsList Vertical">
                      {
                        marker.type === 'home' &&
                        <div className="PopUpCard_wrapper">
                          <h4 className="PopUpCard_title">{get(marker, 'address.streetAddress')}</h4>
                          <span className="PopUpCard_item">{get(marker, 'address.addressLocality')}, {get(marker, 'address.addressRegion')} {get(marker, 'address.postalCode')}</span>
                          <span className="PopUpCard_item">Price: {numeral(get(marker, 'price')).format('$0,0')}</span>
                          <span className="PopUpCard_item">{get(marker, 'status')}</span>
                          <Link name="home-detail" home={marker} className="PopUpCard_link">View Detail</Link>
                        </div>
                      }
                    </div>
                  )}
                  tooltip={marker => (
                    <div>
                      {
                        !marker.isLot &&
                        <span>
                          Available Home
                          <br />
                          {marker.address.streetAddress}
                        </span>
                      }

                      {
                        marker.isLot &&
                        <span>
                          Available Lot
                          <br />
                          {marker.address.streetAddress}
                        </span>
                      }
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CommunitySitePlan.propTypes = {
  community: PropTypes.object.isRequired,
};

export default CommunitySitePlan;



// WEBPACK FOOTER //
// ./src/pages/Communities/CommunitySitePlan.js